"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SksgV2RebootCommandValidation = void 0;
const SksgV2ResetTypeValidation_1 = require("./SksgV2ResetTypeValidation");
class SksgV2RebootCommandValidation {
    static isValid(entity) {
        // If entity.reset_type exists, validate that it has the correct type.
        if (entity.reset_type != undefined) {
            if (!SksgV2ResetTypeValidation_1.SksgV2ResetTypeValidation.isValid(entity.reset_type))
                return false;
        }
        // If entity.force exists, validate that it has the correct type.
        if (entity.force != undefined) {
            if (typeof entity.force !== "boolean")
                return false;
        }
        return true;
    }
}
exports.SksgV2RebootCommandValidation = SksgV2RebootCommandValidation;
